/*
 * @Author       : 萝卜兄台
 * @Date         : 2023-04-11 13:44:53
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-04-11 14:16:38
 * @FilePath     : \vue3-ts-mm\src\store\global.ts
 * @Description  : 这是全局的属性
 */

import { defineStore } from 'pinia'
// import { logList } from '../api/user'

export const globalStore = defineStore({
    id: 'global', // id必填，且需要唯一
    state: () => {
        return {
            lang: 'zh_CN',
            isRouterAlive: true
        }
    },
    actions: {
        // getLogList({ payload, callback }: { payload: any, callback: any }) {
        //     this.tbLoading = true
        //     logList(payload).then(res => {
        //         this.tableList = res.data
        //         this.tbLoading = false
        //     }).catch(() => {
        //         this.tbLoading = false
        //     })
        // }
    }
})